import { Flex, Heading, View, Alert, IconInfoLine, Text } from '@smarterservices/smarter-ui';
import SinglePane from '../../../SinglePane';
import {VerificationInput} from '../../../VerificationInput';
import Loader from '../../../Common/Loader';
import { useAppStore } from '../../../../stores/app';

const SecondCameraSessionEnded = () => {
  return (
    <SinglePane maxHeightPercentage={100}>
      <Flex as="div" direction="column" alignItems="center" justifyContent="center" height="100%" width="100%">
        <View 
          as="div" 
          margin="auto"
          textAlign="center"
          borderRadius="large"
          padding="large"
          borderWidth="small"
          borderColor="primary"
          background="secondary"
          maxWidth="400px"
          shadow="resting"
        >
          <View as="div" margin="0 0 medium 0" textAlign="center">
            <IconInfoLine color="brand" size="large" />
          </View>
          <View as="div" margin="0 0 medium 0" textAlign="center">
            <Text size="large">
                Exam session ended
            </Text>
          </View>
          <View as="div" margin="0 0 medium 0" textAlign="center">
            <Text size="medium">
                Your camera has been turned off and is no longer recording.
            </Text>
          </View>
          <View as="div" margin="0 0 medium 0" textAlign="center">
            <Text size="medium">
                You may now close this window.
            </Text>
          </View>
        </View>
      </Flex>
    </SinglePane>
  );
};

export default SecondCameraSessionEnded;
